import { twMerge } from 'tailwind-merge'

/**
 * State-driven border styling for the {@link DateTimeInput} trigger field.
 * Mirrors the Figma redesign (AOS-618): default subtle border, focus ring on
 * `action.focus-ring`, error on `status.critical`, disabled dimmed.
 */
export type DateTimeInputType = 'date' | 'time'
export type DateTimeInputState = 'default' | 'focus' | 'error' | 'disabled'

const fieldBase =
    'flex-row items-center justify-between h-10 px-3 py-2 rounded border bg-background-input w-full'

const stateBorder: Record<DateTimeInputState, string> = {
    default: 'border-border-subtle',
    focus: 'border-2 border-focus-ring',
    error: 'border-2 border-status-critical',
    disabled: 'border-border-subtle opacity-40',
}

export const dateTimeFieldClasses = (state: DateTimeInputState): string =>
    twMerge(fieldBase, stateBorder[state])
